import api from '@/api';

const resource = 'ei/home';

export default {
  getProfessorHome ({ cdtipesc, cdescola, ano }) {
    return api.get(`${resource}/professor/${cdtipesc}/${cdescola}`, {
      params: { ano },
    });
  },
};
